export const ORDER_SIDE = {
    0: 'Buy',
    1: 'Sell'
}

export const ORDER_TYPE = {
    0: 'Market',
    1: 'Limit',
    2: 'IoC',
    3: 'FoK',
    4: 'MoC'
}